import React from "react";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import EmailIcon from "@mui/icons-material/Email";
import Button from "@mui/material/Button";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import { clearCart } from "@/store/slices/cartSlice";
import { clearOrderState } from "@/store/slices/uiSlice";

const OrderSuccess = () => {
  const dispatch = useDispatch();

  React.useEffect(() => {
    dispatch(clearCart());
    // Clear the order state when the component unmounts
    return () => {
      dispatch(clearOrderState());
    };
  }, [dispatch]);

  return (
    <div className="bg-gradient-to-br from-slate-50 to-slate-100 text-slate-900 min-h-screen flex items-center py-8">
      <div className="container mx-auto px-4">
        <div className="mx-auto max-w-2xl">
          {/* Success Card */}
          <div className="bg-white rounded-2xl p-8 shadow-lg mb-6">
            <div className="flex justify-center mb-6">
              <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center">
                <CheckCircleIcon
                  className="text-green-600"
                  style={{ fontSize: 48 }}
                />
              </div>
            </div>

            <h1 className="font-display text-3xl text-center mb-4">
              Order Confirmed!
            </h1>
            <p className="text-slate-600 text-center text-lg mb-6">
              Thank you for your purchase. Your order has been successfully
              placed and is being processed.
            </p>

            {/* Order Details */}
            <div className="bg-slate-50 rounded-xl p-6 mb-6">
              <h3 className="font-semibold text-slate-900 mb-4">
                Order Details
              </h3>
              <div className="space-y-3">
                <div className="flex justify-between">
                  <span className="text-slate-600">Order Status:</span>
                  <span className="font-medium text-green-600">Confirmed</span>
                </div>
                <div className="flex justify-between">
                  <span className="text-slate-600">Estimated Processing:</span>
                  <span className="font-medium">1-2 business days</span>
                </div>
                <div className="flex justify-between">
                  <span className="text-slate-600">Estimated Delivery:</span>
                  <span className="font-medium">3-5 business days</span>
                </div>
              </div>
            </div>

            {/* Tracking Information */}
            <div className="bg-blue-50 rounded-xl p-6 mb-6">
              <div className="flex items-start gap-3">
                <LocalShippingIcon className="text-blue-600 mt-1" />
                <div>
                  <h3 className="font-semibold text-slate-900 mb-2">
                    Tracking Information
                  </h3>
                  <p className="text-slate-700 mb-3">
                    Your tracking ID will be shared via email once your order is
                    shipped. This typically happens within 1-2 business days
                    after order confirmation.
                  </p>
                  <div className="bg-blue-100 rounded-lg p-3">
                    <p className="text-sm text-blue-800">
                      <strong>What happens next?</strong>
                    </p>
                    <ul className="text-sm text-blue-800 mt-2 space-y-1">
                      <li>• Order processing and quality check</li>
                      <li>• Packaging and shipping preparation</li>
                      <li>• Tracking ID sent to your email</li>
                      <li>• Real-time delivery updates</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            {/* Email Confirmation */}
            <div className="bg-green-50 rounded-xl p-6 mb-6">
              <div className="flex items-start gap-3">
                <EmailIcon className="text-green-600 mt-1" />
                <div>
                  <h3 className="font-semibold text-slate-900 mb-2">
                    Email Confirmation
                  </h3>
                  <p className="text-slate-700">
                    A confirmation email has been sent to your registered email
                    address with all order details. Please check your inbox (and
                    spam folder) for the confirmation.
                  </p>
                </div>
              </div>
            </div>

            {/* Action Buttons */}
            <div className="flex flex-col sm:flex-row gap-3 justify-center">
              <Button
                component={Link}
                to="/shop"
                variant="contained"
                size="large"
                className="bg-blue-600 hover:bg-blue-700"
              >
                Continue Shopping
              </Button>
              <Button
                component={Link}
                to="/order-tracking "
                variant="outlined"
                size="large"
              >
                Track Orders
              </Button>
            </div>
          </div>

          {/* Additional Information */}
          <div className="bg-white rounded-2xl p-6 shadow-lg">
            <h3 className="font-semibold text-slate-900 mb-4">Need Help?</h3>
            <div className="grid md:grid-cols-2 gap-4 text-sm">
              <div>
                <p className="text-slate-600 mb-2">
                  <strong>Customer Support:</strong>
                </p>
                <p className="text-slate-700">
                  If you have any questions about your order, our customer
                  support team is here to help.
                </p>
              </div>
              <div>
                <p className="text-slate-600 mb-2">
                  <strong>Contact Information:</strong>
                </p>
                <p className="text-slate-700">
                  Email: riyaskebrahim@gmail.com
                  <br />
                  Phone: +1 (555) 123-4567
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OrderSuccess;
